import React, { useState } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Validation from '../../../../../../components/Validation';
export default function CategoryTag({
    visible,
    toggle,
    addTag,
}) {
    const [categoryTag, setCategoryTag] = useState("");
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);

    const handleChangeTitle = (e) => {
        setCategoryTag(e.target.value);
    }
    const Add = () => {
        addTag(categoryTag);
        toggle();
    }
    return (
        <Modal isOpen={visible} toggle={() => toggle()}>
            <ModalHeader toggle={() => toggle()}>Category Tag</ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx sm={12} style={{ marginBottom: "10px" }}>
                        <Label>Tag</Label>
                        <Input
                            type="text"
                            name="title"
                            value={categoryTag}
                            onChange={(e) => handleChangeTitle(e)}
                        />
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    onClick={() => Add()}
                >
                    Add
                </Button>
                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Modal>
    )
}